import {Routes} from '@angular/router';
import {DebugSettingComponent} from './features/debug/debug-setting/debug-setting.component';

export const routes: Routes = [
  {path: 'debug-setting', pathMatch: 'full', component: DebugSettingComponent},
  {
    path: 'auth',
    loadComponent: () => import('./features/shell/layouts/account-layout/account-layout.component').then(m => m.AccountLayoutComponent),
    loadChildren: () => import('./features/account/auth.routes').then(m => m.routes),
  },
  {
    path: 'account',
    loadComponent: () => import('./features/shell/layouts/account-layout/account-layout.component').then(m => m.AccountLayoutComponent),
    loadChildren: () => import('./features/account/account.routes').then(m => m.routes),
  },
  {
    path: '', loadComponent: () => import('./features/shell/layouts/base-layout/base-layout.component').then(m => m.BaseLayoutComponent), children: [
      {
        path: 'site', children: [
          {path: 'list', loadComponent: () => import('./features/site-management/pages/site-list/site-list.component').then(m => m.SiteListComponent)},
          {
            path: '', loadComponent: () => import('./features/site-management/pages/site-home/site-home.component').then(m => m.SiteHomeComponent), children: [
              {path: '', pathMatch: 'full', redirectTo: 'dashboard'},
              {path: 'dashboard', loadComponent: () => import('./features/site-management/pages/site-dashboard/site-dashboard.component').then(m => m.SiteDashboardComponent)},
              {path: 'details', loadComponent: () => import('./features/site-management/pages/site-details/site-details.component').then(m => m.SiteDetailsComponent)},
              {path: 'devices', loadComponent: () => import('./features/site-management/pages/site-devices/site-devices.component').then(m => m.SiteDevicesComponent)},
              {path: '**', redirectTo: 'dashboard'}
            ]
          },
        ]
      },
      {
        path: 'device',
        loadChildren: () =>
          import('./features/device-management/device.routes').then(m => m.deviceRoutes),
      },
      {path: 'organization-user-list', loadComponent: () => import('./features/organization-management/pages/organization-management/organization-management.component').then(m => m.OrganizationManagementComponent)},
      {path: 'organization-info', loadComponent: () => import('./features/organization-management/pages/organization-info/organization-info.component').then(m => m.OrganizationInfoComponent)},
      {
        path: 'openapi/client-list',
        title: 'Application Clients',
        loadComponent: () => import('./features/openapi-management/application-client-list/application-client-list.component')
          .then(m => m.ApplicationClientListComponent),
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.routes').then(m => m.routes),
      },
      {path: '**', redirectTo: '/site/list'},
    ],
  },
  // fallback route
  {path: '**', redirectTo: '/site'}
];
